import { jsx } from "react/jsx-runtime";
import MenuIcon from "@mui/icons-material/Menu";
import { validateTidalLicense } from "../../base/index.js";
function Menu(props) {
  return /* @__PURE__ */ jsx(
    MenuIcon,
    {
      "data-testid": "Menu",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Menu",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Menu.tidalIconMeta = {
  categories: "common,navigation",
  name: "Menu"
};
validateTidalLicense();
export {
  Menu
};
//# sourceMappingURL=Menu.js.map
